module.exports = __webpack_public_path__ + "media/components/home/masthead/img/space_530x400@2x-cd5ee0c76d38c5fa9df55551c546348f.jpg";